<template>
  <el-dialog
    title="调价"
    :visible.sync="priceFormVisible"
    width="506px"
    :before-close="cancelHandle"
    :append-to-body="true"
  >
    <el-form :model="priceForm" :rules="priceRules" ref="priceForm" class="priceForm">
      <el-form-item label="调价方式：" label-width="120px" prop="adjustmentType">
        <el-select v-model="priceForm.adjustmentType" placeholder="调价方式" @change="selectChange">
          <el-option
            v-for="item in adjustmentTypeArr"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="priceForm.adjustmentType === 1"
        label="增幅比例(%)："
        label-width="120px"
        prop="percentage"
        key="1"
        :rules="[{ required: true, validator: validateNumber1, trigger: 'blur' }]"
      >
        <el-input v-model.number="priceForm.percentage" placeholder="请输入增幅比例"></el-input>
        <span class="amplification">(1-200)</span>
      </el-form-item>
      <el-form-item
        v-if="priceForm.adjustmentType === 2"
        label="降幅比例(%)："
        label-width="120px"
        prop="percentage"
        key="2"
        :rules="[{ required: true, validator: validateNumber2, trigger: 'blur' }]"
      >
        <el-input v-model.number="priceForm.percentage" placeholder="请输入降幅比例"></el-input>
        <span class="amplification">(1-80)</span>
      </el-form-item>
      <el-form-item
        v-if="priceForm.adjustmentType === 3"
        label="增幅数值："
        label-width="120px"
        prop="adjustmentPrice"
        key="3"
        :rules="[{ required: true, validator: validateNumber35, trigger: 'blur' }]"
      >
        <el-input v-model="priceForm.adjustmentPrice" placeholder></el-input>
        <span class="amplification">元</span>
      </el-form-item>
      <el-form-item
        v-if="priceForm.adjustmentType === 4"
        label="降幅数值："
        label-width="120px"
        prop="adjustmentPrice"
        key="4"
        :rules="[{ required: true, validator: validateNumber4, trigger: 'blur' }]"
      >
        <el-input v-model="priceForm.adjustmentPrice" placeholder></el-input>
        <span class="amplification">元</span>
      </el-form-item>
      <el-form-item
        v-if="priceForm.adjustmentType === 5"
        label="固定数值："
        label-width="120px"
        prop="adjustmentPrice"
        key="5"
        :rules="[{ required: true, validator: validateNumber35, trigger: 'blur' }]"
      >
        <el-input v-model="priceForm.adjustmentPrice" placeholder></el-input>
        <span class="amplification">元</span>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancelHandle">取 消</el-button>
      <el-button type="primary" @click="handleAdjustPrice">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
// /^[1-2]?[0-8]{1,2}/

// const price = /^([1-9]|[1-9]\d|1\d{2}|200)$/; // 1-200
// const price = /^([1-7]\d{0,1}|80)$/; // 1-80
// ^([1-9][0-9]*)+(\.[0-9]{1,2})?$ 正数，最多两位小数
// ^([1-9][0-9]*)+(\.[0-9]{1,3})?$ 正数，最多3位小数

const numberReg = /^\d+$|^\d+[.]?\d+$/
const numberReg2 = /^([0-9][0-9]*)+(\.[0-9]{1,2})?$/
// const numberReg3 = /^([1-9][0-9]*)+(\.[0-9]{1,3})?$/;
const validateNumber1 = (rule, value, callback) => {
  if (!numberReg.test(value) || value < 1 || value > 200) {
    callback(new Error('输入格式必须为1-200整数数字'))
  } else {
    callback()
  }
}
const validateNumber2 = (rule, value, callback) => {
  if (!numberReg.test(value) || value < 1 || value > 80) {
    callback(new Error('输入格式必须为1-80整数数字'))
  } else {
    callback()
  }
}
const validateNumber35 = (rule, value, callback) => {
  if (!numberReg2.test(value) || value < 0 || value > 1000000000) {
    callback(new Error('请输入0-10亿的正数，小数点后最多2位'))
  } else {
    callback()
  }
}

const validateNumber4 = (rule, value, callback) => {
  if (!numberReg2.test(value) || value < 0) {
    callback(new Error('输入格式正数数字，小数点后最多两位'))
  } else {
    callback()
  }
}
/* const validateNumber5 = (rule, value, callback) => {
  if (!numberReg2.test(value)) {
    callback(new Error("输入格式必须正数数字"));
  } else {
    callback();
  }
}; */
const adjustmentTypeArr = [
  // {
  //   key: 1,
  //   value: '按比例增幅'
  // },
  {
    key: 2,
    value: '按比例降幅'
  },
  // {
  //   key: 3,
  //   value: '按数值增幅'
  // },
  {
    key: 4,
    value: '按数值降幅'
  },
  {
    key: 5,
    value: '固定价'
  }
]
export default {
  props: {
    priceFormVisible: {
      type: Boolean,
      default: false
    },
    price: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      priceForm: {
        adjustmentType: 2,
        percentage: '',
        adjustmentPrice: ''
      },
      priceRules: {
        adjustmentType: [{ required: true, message: '请选择调价方式', trigger: 'change' }]
        // percentage: [{ required: true, message: "请填写增/降幅比例", trigger: "change" }],
      },
      adjustmentTypeArr,
      validateNumber1,
      validateNumber2,
      validateNumber4,
      validateNumber35
    }
  },
  mounted() {
    this.$nextTick(() => {
      // this.$refs.priceForm.resetFields();
      console.log(this.$refs)
    })
  },
  methods: {
    selectChange() {
      this.priceForm.percentage = ''
      this.priceForm.adjustmentPrice = ''
    },
    cancelHandle() {
      this.$refs.priceForm.resetFields()
      this.$emit('update:priceFormVisible', false)
    },
    handleAdjustPrice() {
      this.$refs.priceForm.validate(valid => {
        if (valid) {
          const params = { ...this.priceForm }
          if (params.adjustmentPrice) {
            delete params.percentage
          }
          if (params.percentage) {
            delete params.adjustmentPrice
          }
          if (this.priceForm.adjustmentType === 4) {
            if(this.priceForm.adjustmentPrice === 0){
              this.$message({
                message: '集采价不能为0',
                type: 'warning'
              })
              return
            }
            if (this.priceForm.adjustmentPrice - this.price >= 0) {
              this.$message({
                message: '降幅数值不可大于市场公开价',
                type: 'warning'
              })
              return
            }
          }

          this.$emit('handleAdjustPrice', this.priceForm)
          // console.log(this.priceForm, params);
          this.$nextTick(() => {
            this.$refs.priceForm.resetFields()
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.amplification {
  margin-left: 10px;
}
.priceForm {
  ::v-deep .el-input {
    width: 192px;
  }
}
</style>
